import { DialectSdkError, } from '@dialectlabs/sdk';
import { useCallback, useState } from 'react';
import useSWR from 'swr';
import { EMPTY_ARR } from '../utils';
import { WALLET_NOTIFICATION_SUBSCRIPTIONS_CACHE_KEY_FN } from './internal/swrCache';
import useDialectSdk from './useDialectSdk';
function useNotificationSubscriptions({ dappAddress, refreshInterval, }) {
    const { wallet: { address: walletAddress, notificationSubscriptions }, } = useDialectSdk();
    const [isUpdating, setIsUpdating] = useState(false);
    const [errorUpdating, setErrorUpdating] = useState(null);
    const { data: subscriptions, error: errorFetching = null, mutate, } = useSWR(WALLET_NOTIFICATION_SUBSCRIPTIONS_CACHE_KEY_FN(walletAddress, dappAddress), notificationSubscriptions
        ? () => notificationSubscriptions.findAll({ dappAccountAddress: dappAddress })
        : null, {
        refreshInterval,
        refreshWhenOffline: true,
    });
    const update = useCallback(async (command) => {
        setIsUpdating(true);
        setErrorUpdating(null);
        try {
            await notificationSubscriptions.upsert(command);
            await mutate();
        }
        catch (e) {
            if (e instanceof DialectSdkError) {
                setErrorUpdating(e);
            }
            throw e;
        }
        finally {
            setIsUpdating(false);
        }
    }, [mutate, notificationSubscriptions]);
    return {
        subscriptions: subscriptions || EMPTY_ARR,
        update,
        isFetching: subscriptions === undefined && !errorFetching,
        errorFetching,
        isUpdating,
        errorUpdating,
    };
}
export default useNotificationSubscriptions;
//# sourceMappingURL=useNotificationSubscriptions.js.map